import axios from "../config/axios-chatbot";


export const MessageAnnotationsRepository = {

  // POST to create or update message annotation
  createOrUpdate: (dto) => {
    return axios.post(`/api/message-annotation`, dto)
  },

  // GET all annotations by voice assistant ID
  getByVoiceAssistant: (voiceAssistantId) => {
    return axios.get(`/api/message-annotation/voice-assistant/${voiceAssistantId}`)
  },

  // GET all annotations by conversation ID
  getByConversation: (conversationId) => {
    return axios.get(`/api/message-annotation/conversation/${conversationId}`)
  },

  // GET annotation by message ID
  getByMessageId: (messageId) => {
    return axios.get(`/api/message-annotation/message/${messageId}`)
  },

  // GET annotations with pagination and filters
  search: (params) => {
    const queryParams = new URLSearchParams();

    if (params.messageId !== undefined && params.messageId !== null) {
      queryParams.append('messageId', params.messageId);
    }
    if (params.conversationId !== undefined && params.conversationId !== null) {
      queryParams.append('conversationId', params.conversationId);
    }
    if (params.voiceAssistantId !== undefined && params.voiceAssistantId !== null) {
      queryParams.append('voiceAssistantId', params.voiceAssistantId);
    }
    if (params.annotatedText) {
      queryParams.append('annotatedText', params.annotatedText);
    }
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    if (params.resolved !== undefined && params.resolved !== null) {
      queryParams.append('resolved', params.resolved);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page);
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size);
    }
    if (params.sort) {
      queryParams.append('sort', params.sort);
    }
    if (params.direction) {
      queryParams.append('direction', params.direction);
    }

    return axios.get(`/api/message-annotation/search?${queryParams.toString()}`)
  },

  // DELETE annotation by ID
  deleteById: (id) => {
    return axios.delete(`/api/message-annotation/${id}`)
  },

  // PATCH to toggle resolved status
  toggleResolved: (id) => {
    return axios.patch(`/api/message-annotation/${id}/toggle-resolved`)
  },

  // Export annotations to CSV
  // GET /api/message-annotation/export
  // Optional params: startDate, endDate (format: yyyy-MM-dd'T'HH:mm:ss)
  export: (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }

    return axios.get(`/api/message-annotation/export?${queryParams.toString()}`, {
      responseType: 'blob', // Important for file download
    });
  },

  // GET statistics for message annotations
  getStatistics: ({voiceAssistantId}) => {
    return axios.get(`/api/message-annotation/statistics/${voiceAssistantId}`)
  },

  // GET statistics by voice assistant ID
  getStatisticsByVoiceAssistant: (voiceAssistantId) => {
    return axios.get(`/api/message-annotation/statistics/voice-assistant/${voiceAssistantId}`)
  }
};